import { render, staticRenderFns } from "./FormIdActive.vue?vue&type=template&id=2e4a9355&scoped=true&"
import script from "./FormIdActive.vue?vue&type=script&lang=js&"
export * from "./FormIdActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a9355",
  null
  
)

export default component.exports